import { LineIdQuery, LineIdQueryVariables } from "@/graphql/generated/graphql";
import { LineId } from "@/graphql/queries/LineId";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import { UseGetLineIdArgs } from "./useGetLineId.decl";

export function useGetLineId({ callId }: UseGetLineIdArgs) {
  const { data, loading } = useQueryWrapper<LineIdQuery, LineIdQueryVariables>(
    LineId,
    {
      variables: {
        callId,
      },
    }
  );

  return {
    loading,
    lineId: data?.getCall?.lineId ?? null,
  };
}
